// extracted by mini-css-extract-plugin
module.exports = {"not-found-page":"not-found-page__2u_FA","message-box":"message-box__3PWvr","go-home-link":"go-home-link__lOjov"};